module.exports = __webpack_public_path__ + "img/seminar10.e96866e2.jpg";